/**
 * Contratos do endpoint de autenticação do gdic-api
 * (POST /api/v1/auth/login — security/auth/AuthController.java).
 */

/** Corpo da requisição de login (espelha LoginRequest.java). */
export interface LoginRequest {
  email: string;
  senha: string;
  /** Um token vale para um tenant; o id do tenant é obrigatório no login. */
  idTenancy: number;
}

/** Resposta do login (espelha TokenResponse.java). */
export interface TokenResponse {
  accessToken: string;
  /** Sempre "Bearer". */
  tokenType: string;
  expiraEmSegundos: number;
}

/**
 * Papéis de operador do e-SIC. Quem tem ao menos um deles trabalha na visão administrativa:
 * é o que decide o painel de destino após o login e a oferta da troca de visão no menu do
 * usuário. Fora desta lista, o usuário é apenas cidadão.
 *
 * Os três são listados explicitamente, e não deduzidos da hierarquia de papéis, para que a
 * regra fique legível onde é aplicada — quem lê `hasRoleOuSuperior('ESIC_RESPONDENTE')` não vê
 * que gestor e cadastrador também passam.
 */
export const PAPEIS_OPERADOR_ESIC = [
  'ROLE_ESIC_GESTOR',
  'ROLE_ESIC_CADASTRADOR',
  'ROLE_ESIC_RESPONDENTE',
] as const;

/** Papéis de operador da Ouvidoria — mesmo critério de {@link PAPEIS_OPERADOR_ESIC}. */
export const PAPEIS_OPERADOR_OUVIDORIA = [
  'ROLE_OUVIDORIA_ADMIN',
  'ROLE_OUVIDORIA_CADASTRADOR',
  'ROLE_OUVIDORIA_OPERADOR',
] as const;

/** Claims do JWT emitido pelo backend (JwtService: sub, email, tenantId, pessoaId, roles, exp). */
export interface UsuarioAutenticado {
  idUsuario: number;
  email: string;
  tenantId: number;
  pessoaId: number | null;
  /** Authorities no formato ROLE_<GRUPO>_<PAPEL>, ex.: ROLE_ESIC_RESPONDENTE. */
  roles: string[];
  /** Expiração em segundos desde a época (claim exp). */
  exp: number;
}
